import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, tipoPermitido }) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/" />;
  if (user.tipo !== tipoPermitido) return <Navigate to="/" />;

  return children;
};

export default PrivateRoute;
